import React from 'react';

export default function CircularGallery({ items = [], onItemClick }) {
  return (
    <div className="w-full h-full overflow-y-auto no-scrollbar py-10 px-4 md:px-10">
      {/* 🚀 采用三栏/四栏响应式布局，保证图片大而美 */}
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
        {items.map((item) => (
          <div
            key={item.id}
            onClick={() => onItemClick(item)}
            className="group relative aspect-[3/4] rounded-3xl overflow-hidden cursor-pointer border border-white/5 bg-neutral-900 transition-all duration-500 hover:scale-[1.03] hover:border-fuchsia-500/50 shadow-2xl animate-[fadeInUp_0.6s_ease-out_both]"
          >
            {/* 图片硬件加速 */}
            <img
              src={item.image}
              alt={item.text}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
            />
            
            {/* 悬停时的渐变层 */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col justify-end p-8">
              <h3 className="text-white font-bold text-xl mb-2 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                {item.text}
              </h3>
              <p className="text-fuchsia-500 font-mono text-xs tracking-widest uppercase">
                Click to Enlarge
              </p>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}